export const allowOnlyLogged = () =>
  new Promise((resolve) => {
    const token = localStorage.getItem('token')
    resolve(token !== null)
  })
